<template>
    <div :class="'search ' + $store.getters['searchState']" >
      <div class="search__header">
        <input type="text" name="search" placeholder="Chercher" v-model="searched" @keyup="search(searched)" ref="keyword">
        <a href="" class="back"><img src="/static/img/pictos/fleche-gauche-blanche.svg" @click.prevent="toggleSearch()"></a>
        <a href="" class="reset-search"><img src="/static/img/pictos/fermer-blanche.svg" @click.prevent="resetSearch()"></a>
      </div>
      <div class="search__content">
        <div class="search__suggestions suggestions" v-if="results">
          <div class="suggestions__title">
            Suggestions
          </div>
          <div class="suggestions__content content" >
            <a href="" v-if="suggestion.product_id && loading == 0" @click.prevent="redirect(suggestion.product_id)" class="suggestion" v-for="suggestion in results" :key="suggestion.product_id">
            <!-- <router-link v-if="suggestion.product_id && loading == 0" :to="{name: 'ProductDetail', params: {id: suggestion.product_id}}" class="suggestion" v-for="suggestion in results" :key="suggestion.product_id"> -->
              <div class="suggestion__ref">
                {{ suggestion.product_code }}
              </div>
              <div class="suggestion__name" >
                <span v-html="$options.filters.bold(suggestion.product_label, searched)"></span>
                <br/>
                <small>{{ suggestion.family_name }}</small>
              </div>
            </a>
            <div class="suggestions__loader" v-if="loading == 1">
              <i></i>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>
export default {
  name: "Search",
  data() {
    return {
      searched: "",
      loading: 0
    }
  },
  created: function(){
    var currentUrl = window.location.pathname;
  },
  computed: {
    results: function() {
      let results = this.$store.getters['search/getResults'];
      return results;
    }
  },
  filters: {
    bold: function (res, searched) {
      if (!res) return ''
      return res.replace(searched, '<strong>' + searched + '</strong>');
    }
  },
  methods: {
    // Affiche ou cache la recherche
    toggleSearch(){
      this.resetSearch();
      this.$store.dispatch('toggleSearch');
    },
    // Vide le champ de recherche
    resetSearch(){
      const self = this;
      this.$store.dispatch('search/setResults', null).then(function(){
        self.$refs.keyword.value = '';
        self.searched = "";
      });
    },
    // Méthode de recherche
    search(searched){
      // Si on n'est pas déjà en train d'effectuer une recherche
      if(this.loading == 0){

        // On lance la recherche donc on passe l'info au composant
        this.loading = 1;

        // envoi de la requête au back avec le mot tapé en paramètre post (predicate)
        this.$http.post('product/search', {
          predicate: searched,
        }).then(response => {

          // Dans le retour Ajax on enregistre les résultats de la recherche avec le résultat retourné par le back
          this.$store.dispatch('search/setResults', response.data);

          // On indique au composant que la recherche est terminée pour qu'une nouvelle recherche puisse être faite.
          this.loading = 0;
        }).catch(error => {

          // Erreur lors de la requête AJAX : on indique que la recherche est terminée
          this.loading = 0;
        })
      }else{

      }
    },
    redirect(id){
      var currentUrl = window.location.pathname;

      // Tant que l'url du détail produit est différente de la page courante, on redirige dessus
      if(currentUrl !== '/product/'+id){
        this.$router.push({name: 'ProductDetail', params: {id: id}});

      // Sinon on cache juste la recherche
      }else{
        this.toggleSearch();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::placeholder{ color: white; }

  .search{ position: fixed; height: 100vh; width: 100%; left: 0; top: -100vh; background-color: $color1; z-index: 100; transition: top 300ms ease-in-out; display: flex; flex-direction: column;
    &.active{ top: 0; }
    &__header{ height: auto; padding: 100px 30px 30px 30px;
      input{ background-color: transparent; border: none; width: 100%; color: $color3; border: none; height: 35px; line-height: 35px; font-size: 25px; outline: none; font-family: 'ClanPro'; padding-right: 30px; }
      input:-internal-autofill-selected{ display: none; background-color: transparent !important;  }
      a.back{ position: absolute; top: 10px; right: 30px;
        img{ width: 30px; }
      }
      a.reset-search{position: absolute; top: 104px; right: 30px;
         img{ width: 20px; }
      }
    }
    &__content{ background-color: white; flex: 1; padding: 20px 30px;  overflow: auto;
      .suggestions{ display: flex; position: relative;
        &__title{ color: $color3; font-size: 16px; font-family: 'ClanPro'; width: 130px;

        }
        &__content{
          .suggestion{ display: flex; font-size: 16px; font-family: 'ClanPro'; margin-bottom: 10px;
            &__ref{ margin-left: 40px; margin-right: 20px; color: $grisfonce; font-size: 12px; width: 80px; }
            &__name{ font-family: 'ClanPro'; flex: 1; color: $grisfonce;
              span{
                strong{ font-family: 'ClanProBold'; }
              }
              small{ font-family: 'ClanPro'; font-size: 11px; }
            }
            &:hover{ text-decoration: none; }
          }
        }
        &__loader { background-color: $color1; height: 50px; width: 50px; border-radius: 50%; text-align: center; position: absolute; top: 0; left: 50%; transform: translateX(-50%);
            i { display: block; margin: 0 auto;
              &:before { content: "."; animation-name: load; animation-duration: 800ms; animation-iteration-count: infinite; width: auto; color: white; display: inline-block; font-size: 23px;
              }
            }
          }
      }
    }
  }
  @media screen and (max-width: 450px){
    .search__content{
      .suggestions{ width: 100%; display: block !important;
        &__title{ margin-bottom: 20px; }
      }
      .suggestion{
        &__ref{ margin-left: 0 !important; }
      }
    }
  }



  @keyframes load {
    0% {
      content: ".";
    }
    33% {
      content: "..";
    }
    66% {
      content: "...";
    }
    100% {
      content: ".";
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/Search.vue